module.exports = __webpack_public_path__ + "static/media/lucastswick-generative-artist-logo-white.00cecad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/lucastswick-generative-artist-logo-white.png
// module id = 4916
// module chunks = 14